import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { Logger } from '../services/logger/logger';
import { LOGGER } from '../consts/log.enum';
import { MESSAGE_ERROR_AUTHORIZATION, MESSAGE_ERROR_SERVICE_UNAVAILABLE } from '../consts/messages.const';
import { INTERCEPTOR_SKIP_ALL_HEADER } from '../consts/interceptor';
import { IErrorResponse } from '../types/response.type';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  private logger = inject(Logger);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // fixme
    if (request.headers.has(INTERCEPTOR_SKIP_ALL_HEADER)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.body) {
          this.logger.log(`%cService ${request.url} result`, LOGGER.requestResult, event.body);
        }
      }),
      catchError((res) => {
        let message: string | null = null;

        if (res instanceof HttpErrorResponse) {
          // для 500 ошибок - не выводить лог
          if (res.status && Math.floor(res.status / 100) !== 5) {
            message = res.error?.error?.message ?? res.error?.message ?? null;
          }

          if (res.status === 401 && !message) {
            message = MESSAGE_ERROR_AUTHORIZATION;
          }
        }

        const err = new Error(message ?? MESSAGE_ERROR_SERVICE_UNAVAILABLE) as Error & IErrorResponse;
        err.error = { message: err.message };

        return throwError(() => err);
      }),
    ) as Observable<HttpEvent<unknown>>;
  }
}
